import React from "react";
import { Nav } from "./Nav";
import { ReactComponent as Construction } from "./construction.svg";

export function Activities() {
  return (
    <Nav>
      <Construction />
    </Nav>
  );
}
